export default __webpack_public_path__ + "static/media/pytorch.48338b80.svg";